import {
  IN_ANALYSIS_BY_LEGAL,
  COMPLETED,
  NOTIFICATION_INITIAL_ANALYSIS,
  SCHEDULED_PAYMENT,
  LEGAL_PROCESS_TREATMENT,
  PAYMENT_COMPLETED
} from './constants';
import { statusBlue, statusGreen, statusOrange, statusYellow } from './colors';

export const getColorFromString = (str: string): string => {
  let statusColor = '';

  switch (str) {
    case IN_ANALYSIS_BY_LEGAL:
      statusColor = statusBlue.main;
      break;
    case COMPLETED:
      statusColor = statusGreen.main;
      break;
    case NOTIFICATION_INITIAL_ANALYSIS:
      statusColor = statusYellow.contrast;
      break;
    case SCHEDULED_PAYMENT:
      statusColor = statusOrange.main;
      break;
    case PAYMENT_COMPLETED:
      statusColor = statusBlue.main;
      break;
    case LEGAL_PROCESS_TREATMENT:
      statusColor = statusOrange.main;
      break;
    default:
      statusColor = '';
      break;
  }

  return statusColor;
};

export const rem = (px: number): string => `${px / 16}rem`;

export function hasReportSource(details?: string | null): boolean {
  if (!details) return false;

  try {
    const parsed = JSON.parse(details);
    return parsed?.source === 'report';
  } catch {
    return false;
  }
}

export function normalizeAddress(address: string): string {
  const addressWithoutCommas = address.replace(/,/g, '');
  const addressWithoutKM = addressWithoutCommas.replace(/\bKM\w*\b/gi, '').trim();
  const addressWithoutDash = addressWithoutKM.replace(/-\s*$/, '');
  const regex = /BR\s*(\d+)/i;
  const match = addressWithoutDash.match(regex);

  if (match && match[1]) {
    return `BR ${match[1]}`;
  }

  return addressWithoutDash;
}
